export default "__VITE_ASSET__9PgpT7dF__"